import React from 'react'

function SubscriptionsAdmin() {
    return (
        <>
            <h3 className="header__title">
                Subscriptions
            </h3>
            <div className="card">
                <h2 className="title text--center primary--text">Coming Soon!</h2>
            </div>
        </>
    )
}

export default SubscriptionsAdmin
